import { Lookup } from '../lookup.interface';
export const ConsentMethods: { [name: string]: Lookup } = {
  electronic: { displayValue: 'Electronic', code: 'Electronic' },
  written: { displayValue: 'Written', code: 'Written' },
  verbal: { displayValue: 'Verbal', code: 'Verbal' },
};
